import { StaffAvailabilityService } from 'libs/staff-availability-lib/src/lib/services/staff-availability.service';
import { CommonModule, DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import {
  RruleComponent,
  SelectRoomComponent,
} from '@fitness-force/shared';
import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';

import { SkeletonModule } from 'primeng/skeleton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import {
  CancelClassRequest,
  Class,
  ClassById,
  ClassType,
  ClassTypeById,
  Client,
  IPSetting,
  RepeatRuleResponse,
  RescheduleClassRequest,
  RescheduleRecurringClassRequest,
  Room,
  SubstituteCoachInClassRequest,
  UpdateClassRequest,
} from '@fitness-force/models';

import {
  TimeconversionService,
  ClassService,
  ClassTypeService,
  ToastMessageService,
} from '@fitness-force/api';
import { Store } from '@ngrx/store';
import {
  CLASS_TYPE_STATE,
  LOCATION_STATE,
  STAFF_STATE,
} from 'apps/ff-frontend/src/app/state/app.state';
import { BehaviorSubject, debounceTime, Observable, Subject } from 'rxjs';
import { CONSTANTS_SCHEDULE } from '@fitness-force/constants';
import {
  ClassAppointmentBehaviour,
  ClassStatus,
  ClientBookingStatus,
  Ienum,
  StaffStatus,
} from '@fitness-force/enum';
import { rrulestr } from 'rrule';
import { InputNumberModule } from 'primeng/inputnumber';
import { GooglePlacesComponent } from '@fitness-force/common/google-places';
import { DuplicateClassComponent } from '../duplicate-class/duplicate-class.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ClassClientBookingComponent } from '../class-client-booking/class-client-booking.component';
import { DrawerModule } from 'primeng/drawer';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputNumberComponent } from 'libs/shared/src/lib/components/input-number/input-number.component';
import { CheckRecurringAvailability, StaffAvailableResponse } from 'libs/staff-availability-lib/src/lib/models/staff-availability';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'view-class',
  templateUrl: './view-class.component.html',
  styleUrls: ['./view-class.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  standalone: true,
  imports: [CommonModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    SelectModule,
    FormsModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    RruleComponent,
    AssignedToComponent,
    ErrorMsgComponent,
    SkeletonModule,
    PopoverModule,
    DateTimeFormatPipe,
    ScrollPanelModule,
    InputNumberModule,
    GooglePlacesComponent,
    DuplicateClassComponent,
    ClassClientBookingComponent,
    RadioButtonModule,
    AvatarModule,
    DrawerModule,
    SelectRoomComponent,
    ToggleSwitchModule,
    InputNumberComponent,
    ConfirmPopupModule,
    TranslateModule]
})
export class ViewClassComponent implements OnInit {
  @Input('visible') viewClass: boolean = false;
  @Input('tenantId') tenantId: number = 0;
  @Input('eventData') eventData: any;
  @Input('classData') classData!: Class;
  @Output('CloseViewClass') hideViewClass: EventEmitter<boolean> = new EventEmitter();
  @Output('emitUpdatedData') emitUpdatedData: EventEmitter<any> = new EventEmitter();
  @Output('reloadData') reloadData: EventEmitter<any> = new EventEmitter();

  showApptSubType = new BehaviorSubject(false);
  getAccessedStaffList$: Observable<any> | any;
  classTypeList$ = new BehaviorSubject<ClassType[]>([]);
  classSubTypeList$ = new BehaviorSubject<any[]>([]);
  roomList$ = new BehaviorSubject<any[]>([]);
  classObj!: ClassById;
  selectedClassSubType: Observable<any> | any;
  selectedClassType: Observable<ClassType> | any;
  selectedTrainerId = new BehaviorSubject(0);
  selectedRoomId = new BehaviorSubject(0);
  selectedBehaviourType: any;
  selectedRoom: { name: string } | any;
  selectedTrainer: | { name: string; availability: string; ff_picture: string } | undefined;
  classViewForm: UntypedFormGroup = new UntypedFormGroup({});
  deleteClassForm: UntypedFormGroup = new UntypedFormGroup({});
  updateEventForm: UntypedFormGroup = new UntypedFormGroup({});
  isVirtal: boolean = false;
  duplicateClass: boolean = false;
  behaviourTypes:any = CONSTANTS_SCHEDULE.CLASS_APPOINTMENT_BEHAVIOUR;
  types = ClassAppointmentBehaviour;
  showClientDetails= new BehaviorSubject(false);

  behaviours(): Array<string> {
    var keys = Object.keys(this.types);
    return keys.slice(keys.length / 2);
  }

  showRRule: boolean = false;
  RRuleObject = <RepeatRuleResponse>{};
  minimumDate = new Date();
  errorDataModal = [] as any;
  errorMessages = [] as any;
  showErrorPopup$ = new BehaviorSubject(false);
  reservationLimitEdit: boolean = false;
  waitListEdit: boolean = false;
  dropIns!: any[];
  selectedDropin: { name: string; value: boolean } | undefined;

  markCompleted: boolean = false;
  markAllAttended: boolean = false;

  cancelClassPopup: boolean = false;
  deleteClassPopup: boolean = false;
  showAddClientConfirmPopup: boolean = false;

  searchlocations: Observable<any[]> | any;
  selectedLocation: { name: string; lat: number; lon: number } | any = {};
  currentLocation!: IPSetting;
  selectedClient: Client | any;
  showRecurringEventUpdatePopup: boolean = false;
  updateEvent: string = '';
  currentRequestPayload: any;
  updateData: any;
  rescheduleDate: any;
  rescheduleTime: any;
  claims: string[] = ['can_take_class'];
  isClassCompletedOrCancelled: boolean = false;
  showMiniSearch = new BehaviorSubject<boolean>(true);
  filterStaffIds = new BehaviorSubject<number[]>([0]);
  memberstatus: any[];
  classDataObject = this.classData;
  showLeftView: boolean = false;
  showMedicalAlert: boolean = false;
  classActions: any[];
  selectedClassAction: { key:string, name: string, icon: string; } | undefined;
  private url = new Subject<string>();
  private comments = new Subject<string>();
  isAcceptTrialChecked:boolean= false;
  staffAppointmentAvailability: any = new Map();
  isStaffAvailable:boolean=true;
  showSkeleton:boolean=false;
  btnLoading:boolean=false;
  checkAvailability:boolean=true;

  constructor(
    private store: Store,
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private toastMessageService: ToastMessageService,
    private classTypeService: ClassTypeService,
    private classService: ClassService,
    private timeConversionService: TimeconversionService,
    public datePipe: DatePipe,
    public staffAvailabilityService : StaffAvailabilityService,
    public cd: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
  ) {

    this.classActions = [
      { key:"DUPLICATE", name: 'Make a Duplicate Class', icon: 'fa fa-copy font-light', show:true },
      { key:"CANCEL_CLASS", name: 'Cancel this Class', icon: 'fa fa-minus-circle', show:true },
      { key:"DELETE", name: 'Delete this class', icon: 'fa fa-times text-xl-circle', show:true },
      { key:"CONVERT_PHYSICAL", name: 'Convert this class to Virtual', icon: 'fa fa-building', show:true },
      { key:"CONVERT_VIRTUAL", name: 'Convert this class to Virtual', icon: 'fa fa-video', show:true }
    ];

    this.dropIns = [{ name: 'Allowed', value: true },{ name: 'Not Allowed', value: false }];
    this.searchlocations = [];
   
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.selectedTrainerId.next(this.classData.coach_id);
    this.selectedRoomId.next(this.classData.room_id);
    this.selectedDropin = this.dropIns.find((d) => d.value == this.classData.is_dropin_allowed);
    this.isClassCompletedOrCancelled = this.classData.status == ClassStatus.Completed.toString()
      || this.classData.status == ClassStatus[ClassStatus.Completed]
      || this.classData.status == ClassStatus.Cancelled.toString()
      || this.classData.status == ClassStatus[ClassStatus.Cancelled] ? true : false;
    this.LoadForm();
    this.GetClass();
    this.GetClassTypes();
    this.GetStaffs();
    this.store.select(LOCATION_STATE).subscribe((responseData: IPSetting) => {
      this.currentLocation = responseData;
    });
  }

  ngAfterViewInit() {
    this.deleteClassForm = this.fb.group({cancellation_reason: ['']});
    this.updateEventForm = this.fb.group({updateEvent: ['thisevent', [Validators.required]]});
    this.comments.pipe(debounceTime(2000)).subscribe(() => {
     this.EditCommnentsEvent();
    });

    this.url.pipe(debounceTime(2000)).subscribe(() => {
      this.UpdateVirtualURLEvent();
     });
  }

  LoadForm() {
    this.isAcceptTrialChecked= this.classData.accepts_trial;
    this.classViewForm = this.fb.group({
      classType: [{value:'', disabled:true}],
      classSubType: [{value:'', disabled:true}],
      selectedBehaviourType: [{value:'', disabled:true}],
      selectedTrainer: ['', [Validators.required]],
      startDate: [this.classData.start_datetime, [Validators.required]],
      selectedRoom: [''],
      comments: [''],
      virtualUrl: [''],
      maxCapacity: [this.classData.max_capacity, [Validators.required]],
      maxWaitlist: [this.classData.max_waitlist, [Validators.required]],
      isDropInAllowed: [this.selectedDropin, [Validators.required]],
      rRule: [''],
      placeName: [''],
      placeId: [this.classData.place_id],
      latitude: [this.classData.latitude],
      longitude: [this.classData.longitude],
      accepts_trial:[this.isAcceptTrialChecked],
      selectedAction:[]
    });

    if (this.isClassCompletedOrCancelled) {
      Object.keys(this.classViewForm.controls).forEach((field) => {
        const control = this.classViewForm.get(field);
        if(field !='selectedAction')
         control?.disable({ onlySelf: true });
      });
    }
    if(this.isClassCompletedOrCancelled)
    this.classActions.forEach(o =>{
      if(o.key.toLowerCase() =='cancel_class' || o.key.toLowerCase() =='convert_physical' || o.key.toLowerCase() =='convert_virtual' )
        o.show = false;
    });
    else if(this.isVirtal)
      this.classActions.forEach(o => {if(o.key.toLowerCase() == 'convert_virtual') o.show = false;});
    else
      this.classActions.forEach(o => {if(o.key.toLowerCase() == 'convert_physical')o.show = false;});
  }

  GetClass() {
    this.classService.GetClass(this.tenantId, this.classData!.id).subscribe({
      next: (response: ClassById) => {
        this.classObj = response;
        this.showClientDetails.next(true);
        this.markCompleted = this.classObj.status == ClassStatus.Completed.toString() || this.classObj.status == ClassStatus[ClassStatus.Completed] ? true : false;
        this.CommentsFormControl.setValue(this.classObj.comments);
        this.MaxCapacityFormControl.setValue(this.classObj.max_capacity);
        this.MaxWaitListFormControl.setValue(this.classObj.max_waitlist);
        this.VirtualUrlFormControl.setValue(this.classObj.virtual_url);
        this.RRuleObject.RRule = this.classObj.recurring_rule;
        this.RRuleObject.RRuleText = rrulestr(this.classObj.recurring_rule).toText();

        this.isVirtal = this.classObj?.is_virtual;
        if(this.markCompleted)
          this.classActions.forEach(o =>{
            if(o.key.toLowerCase() =='cancel_class' || o.key.toLowerCase() =='convert_physical' || o.key.toLowerCase() =='convert_virtual' )
              o.show = false;
          });
        else if(this.classObj.is_virtual)
         this.classActions.forEach(o => {if(o.key.toLowerCase() == 'convert_virtual') o.show = false;});
        else
          this.classActions.forEach(o => {if(o.key.toLowerCase() == 'convert_physical')o.show = false;});

          this.GetClassType(this.classObj.type_id);
        },
        error: (error) => {
          this.showClientDetails.next(true);
        },
    });
  }

  GetClassTypes() {
    this.store.select(CLASS_TYPE_STATE).subscribe((responseData: ClassType[]) => {
        this.classTypeList$.next(responseData);
        this.selectedClassType = this.classTypeList$.value.find((type: { id: number }) => type.id == this.classData.type_id);
        this.SelectedClassTypeFormControl.setValue(this.selectedClassType);
        this.selectedBehaviourType = this.behaviourTypes.find((b:any) => b.value == this.classData.behaviour);
        this.SelectedBehaviourTypeFormControl.setValue(this.selectedBehaviourType);
      });
  }

  GetClassType(classTypeId: number) {
    this.classTypeService.getSingleClassType(this.tenantId, classTypeId).subscribe({
        next: (response: ClassTypeById) => {
          if (response.subtypes) {
            this.classSubTypeList$.next(response.subtypes);
            this.selectedClassSubType = response.subtypes.find(
              (subType: { name_primary_language: string }) =>
                subType.name_primary_language.toLowerCase() == this.classObj.subtype_name_primary_language.toLowerCase()
              );
            if (this.selectedClassSubType)
               this.SelectedClassSubTypeFormControl.setValue(this.selectedClassSubType);
             else
               this.selectedClassSubType = response.subtypes[0];
          } else {
            this.selectedClassSubType = null;
          }
        },
        error: () => {
          this.selectedClassSubType = null;
        },
      });
  }


  GetStaffs()
  {
      this.store.select(STAFF_STATE).subscribe((data: any) => {
        if (data && data.staffList && data.staffList.length > 0)
        {
          let validStaff: number[] = [];
          this.getAccessedStaffList$ = data.staffList.filter((staff: any) =>
          {
            let oStaffStatus = this.OStaffStatus.find((o: any) => (o.value == staff.status || o.key == staff.status));
            if(oStaffStatus!.value == StaffStatus.Active || oStaffStatus!.key == StaffStatus.Active)
            {
              if(staff.role.toLowerCase() =='admin' || (staff.role.toLowerCase() == 'staff' && staff.can_take_class))
              {
                validStaff.push(staff.id);
                return staff;
              }
            }
          });
          this.filterStaffIds.next(validStaff);
        }
      });
  }

  ToggleVirtual(isVirtual: boolean) {
    this.isVirtal = isVirtual;
    if (isVirtual) {
      this.classActions.forEach(o =>{ if(o.key.toLowerCase() =='convert_virtual') o.show = false});
      this.classActions.forEach(o =>{ if(o.key.toLowerCase() =='convert_physical') o.show = true});
      this.SelectedRoomFormControl.setValidators(null);
      this.VirtualUrlFormControl.setValidators(null);
      this.UpdateVirtualURLEvent();

    } else {
      this.classActions.forEach(o =>{ if(o.key.toLowerCase() =='convert_physical') o.show = false});
      this.classActions.forEach(o =>{ if(o.key.toLowerCase() =='convert_virtual') o.show = true});
      this.SelectedRoomFormControl.setValidators(this.selectedClassType && this.selectedClassType.is_room_mandatory ? Validators.required: null);
      this.VirtualUrlFormControl.setValidators(null);
      this.UpdateVirtualURLEvent();
      if(this.selectedClassType.is_room_mandatory && (this.SelectedRoomFormControl.value == null || this.SelectedRoomFormControl.value ==''))
      {
        this.classViewForm.markAllAsTouched();
      }
      else{
        this.updateRoom();
      }
    }
  }

  ClosePopup() {
    this.viewClass = false;
    this.hideViewClass.emit(this.viewClass);
  }

  CloseViewClass(event: any) {
    this.ClosePopup();
  }

  async OnScheduleDateSelect(e: any) {
    let changedDate = this.StartDateFormControl.value;
    if (this.GetStartDateFormValue && this.classData.start_datetime != this.GetStartDateFormValue) {
      this.updateEvent = 'OnScheduleDateTimeChange';
      if (this.classObj!.is_recuring) {
        if(changedDate > this.classData.end_datetime)
        {
          this.checkAvailability= true;
          this.showRecurringEventUpdatePopup = true;
        }
        else{
          this.checkAvailability= false;
          this.showRecurringEventUpdatePopup = true;
        }
      } else {
        this.checkStaffAvailability();
        await this.timeout(1000);
        this.RescheduleClass();
      }
    }
  }

  getSelectedRoomEvent(room:Room){
    this.updateEvent = 'RoomChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    if (this.classObj!.is_recuring) {
      this.showRecurringEventUpdatePopup = true;
    } else {
      this.updateRoom();
    }
  }


  getSelectedStaff(trainer: any) {
    this.onTrainerChange(trainer);
  }

  updateRoom() {
    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.classData!.room_id = this.GetSelectedRoomFormValue ? this.GetSelectedRoomFormValue.id : 0;
        if ( this.classObj!.is_recuring && this.SelectedUpdateEventFormControlValue.toLowerCase() != 'thisevent')
        {
          this.reloadData.emit(true);
        } else {
          this.emitUpdatedData.emit({class: this.classData,event: this.eventData});
        }
      } else {
        this.selectedRoomId.next(this.classData!.room_id);
      }
    });
  }

  onDropInChange(event: any) {
    this.updateEvent = 'DropInChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    if (this.classObj!.is_recuring) {
      this.showRecurringEventUpdatePopup = true;
    } else {
      this.UpdateDropInStatus();
    }
  }

  UpdateDropInStatus() {
    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.classData!.is_dropin_allowed = this.GetDropInFormValue;
        if (this.classObj!.is_recuring && this.SelectedUpdateEventFormControlValue.toLowerCase() != 'thisevent') {
          this.reloadData.emit(true);
        } else {
          this.emitUpdatedData.emit({
            class: this.classData,
            event: this.eventData,
          });
        }
      } else {
        this.selectedDropin = this.dropIns.find((d) => d.value == this.classData!.is_dropin_allowed);
        this.DropInFormControl.setValue(this.selectedDropin);
      }
    });
  }


  onAcceptTrialChange(event: any) {
    this.isAcceptTrialChecked= event.checked;
    this.updateEvent = 'AcceptsTrialChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    if (this.classObj!.is_recuring) {
      this.showRecurringEventUpdatePopup = true;
    } else {
      this.UpdateAcceptsTrial();
    }
  }


  UpdateAcceptsTrial() {
    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.AcceptsTrialFormControl.setValue(this.isAcceptTrialChecked);
        if (this.classObj!.is_recuring && this.SelectedUpdateEventFormControlValue.toLowerCase() != 'thisevent') {
          this.reloadData.emit(true);
        } else {
          this.classData!.accepts_trial = this.isAcceptTrialChecked;
          this.emitUpdatedData.emit({
            class: this.classData,
            event: this.eventData,
          });
        }
      } else {
        this.AcceptsTrialFormControl.setValue(this.classData!.accepts_trial);
      }
    });
  }

  async onTrainerChange(trainer: any) {
    let substituteCoach: SubstituteCoachInClassRequest = {} as SubstituteCoachInClassRequest;
    substituteCoach.coach_id = trainer.id;
    this.updateEvent = 'TrainerChange';
   
    this.currentRequestPayload = substituteCoach;
    if (this.classObj!.is_recuring) {
      this.showRecurringEventUpdatePopup = true;
    } else {
      this.checkStaffAvailability();
      await this.timeout(500);
      await this.SubstituteCoach(substituteCoach);
    }
  }

  public onCommentsKeyUpDelay(value: string): void {
    this.comments.next(value);
  }

  public onKeyUpDelay(value: string): void {
    this.url.next(value);
  }

  EditCommnentsEvent() {
    this.updateEvent = 'CommentsChange';
    if (this.classObj!.is_recuring) {
      this.currentRequestPayload = this.GetClassUpdateData();
      this.showRecurringEventUpdatePopup = true;
    } else {
      this.UpdateCommnets();
    }
  }

  UpdateCommnets() {
    let updateData = this.GetClassUpdateData();
    this.UpdateClass(updateData).then((res) => {
      if (res) {
        this.classObj!.comments = updateData.comments;
        if (this.classObj!.is_recuring && this.SelectedUpdateEventFormControlValue.toLowerCase() != 'thisevent') {
          this.reloadData.emit(true);
        } else {
          this.emitUpdatedData.emit({class: this.classData,event: this.eventData});
        }
      } else {
        this.CommentsFormControl.setValue(this.classObj!.comments);
      }
    });
  }

  EditMaxCapacity(event: boolean) {
    this.reservationLimitEdit = false;
    if (event) {
      this.updateEvent = 'MaxCapacityChange';
      if (this.classObj!.is_recuring) {
        let updateData = this.GetClassUpdateData();
        this.currentRequestPayload = updateData;
        this.showRecurringEventUpdatePopup = true;
      } else {
        this.UpdateMaxCapacityAndWaitlist();
      }
    } else {
      this.MaxCapacityFormControl.setValue(this.classData.max_capacity);
    }
    this.MaxCapacityFormControl.updateValueAndValidity();
  }

  EditMaxWaitlist(event: boolean) {
    this.waitListEdit = false;
    if (event) {
      this.updateEvent = 'MaxWaitlistChange';
      if (this.classObj!.is_recuring) {
        let updateData = this.GetClassUpdateData();
        this.currentRequestPayload = updateData;
        this.showRecurringEventUpdatePopup = true;
      } else {
        this.UpdateMaxCapacityAndWaitlist();
      }
    } else {
      this.MaxWaitListFormControl.setValue(this.classData.max_waitlist);
    }
  }

  UpdateMaxCapacityAndWaitlist() {
    let updateData = this.GetClassUpdateData();
    this.UpdateClass(updateData).then((res) => {
      if (res) {
        this.classData!.max_capacity = updateData.max_capacity;
        this.classObj.max_capacity = updateData.max_capacity;
        this.classData!.max_waitlist = updateData.max_waitlist;
        this.classObj.max_waitlist = updateData.max_capacity;
        this.MaxCapacityFormControl.setValue(this.classData.max_capacity);
        this.MaxWaitListFormControl.setValue(this.classData.max_waitlist);
        if (this.classObj!.is_recuring && this.SelectedUpdateEventFormControlValue.toLowerCase() != 'thisevent') {
          this.reloadData.emit(true);
        } else {
          this.emitUpdatedData.emit({class: this.classData,event: this.eventData});
        }
      } else {
        this.MaxCapacityFormControl.setValue(this.classData.max_capacity);
        this.MaxWaitListFormControl.setValue(this.classData.max_waitlist);
      }
      this.MaxCapacityFormControl.updateValueAndValidity();
      this.MaxWaitListFormControl.updateValueAndValidity();
    });
  }

  UpdateVirtualURLEvent() {
      this.updateEvent = 'VirtualUrlChange';
      if (this.classObj!.is_recuring) {
        this.currentRequestPayload = this.GetClassUpdateData();
        this.showRecurringEventUpdatePopup = true;
      } else {
        this.UpdateVirtualUrl();
      }
  }

  UpdateVirtualUrl() {
    let updateData = this.GetClassUpdateData();
    this.UpdateClass(updateData).then((res) => {
      if (res) {
        this.classData!.is_virtual = updateData.is_virtual;
        this.classData.room_id = updateData.room_id;
        this.classObj!.virtual_url = updateData.virtual_url;
        if (
          this.classObj!.is_recuring &&
          this.SelectedUpdateEventFormControlValue.toLowerCase() != 'thisevent'
        ) {
          this.reloadData.emit(true);
        } else {
          this.emitUpdatedData.emit({
            class: this.classData,
            event: this.eventData,
          });
        }
      } else {
        this.VirtualUrlFormControl.setValue(this.classObj!.virtual_url);
      }
    });
  }

  FetchRRuleData(e: any): void {
    this.RRuleObject.RRule = e.RRule;
    this.RRuleObject.RRuleText = e.RRuleText;
    this.OnScheduleDateSelect(null);
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  getPlaceDetails(place: any) {
    this.selectedLocation.name = place.formatted_address;
    this.selectedLocation.lat = place.geometry.location.lat();
    this.selectedLocation.lon = place.geometry.location.lng();
    this.PlaceNameControl.setValue(this.selectedLocation.name);
    this.PlaceIdFormControl.setValue(place.place_id);
    this.LatitudeFormControl.setValue(this.selectedLocation.lat);
    this.LongitudeFormControl.setValue(this.selectedLocation.lon);

    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.emitUpdatedData.emit({
          class: this.classData,
          event: this.eventData,
        });
      } else {
      }
    });
  }

  GetClassUpdateData(): UpdateClassRequest {
    let updateClassRequest: UpdateClassRequest = {} as UpdateClassRequest;
    updateClassRequest.room_id = this.isVirtal ? 0 : this.GetSelectedRoomFormValue ? this.GetSelectedRoomFormValue.id : 0;
    updateClassRequest.is_virtual = this.isVirtal;
    updateClassRequest.virtual_url = this.isVirtal ? this.GetVirtualUrlFormValue : '';
    updateClassRequest.comments = this.GetCommentsFormValue;
    updateClassRequest.max_capacity = this.GetMaxCapacityFormValue;
    updateClassRequest.max_waitlist = this.GetMaxWaitListFormValue;
    updateClassRequest.is_dropin_allowed = this.GetDropInFormValue;
    updateClassRequest.place_id = this.PlaceIdFormControl.value;
    updateClassRequest.latitude = this.LatitudeFormControl.value;
    updateClassRequest.longitude = this.LongitudeFormControl.value;
    updateClassRequest.accepts_trial = this.AcceptsTrialFormControl.value;
    return updateClassRequest;
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      this.toastMessageService.showErrorMessage(error.originalError.error.errorMessage);
    }
  }

  async UpdateClass(updateClassRequest: UpdateClassRequest): Promise<boolean> {
    let promise: Promise<boolean> = new Promise((resolve, reject) => {
      let service = new Observable<any>();
      if (this.classObj!.is_recuring && this.SelectedUpdateEventFormControlValue.toLowerCase() != 'thisevent')
      {
        service = this.classService.UpdateRecurringClass(this.tenantId,this.classObj!.recurring_id,updateClassRequest);
      } else {
        service = this.classService.UpdateClass(this.tenantId,this.classObj!.id,updateClassRequest);
      }
      service.subscribe({
        next: (data: any) => {
          this.translate.get('SCHEDULE.VIEWCLASS.MSG.CLASS_UPDATE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          resolve(true);
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
          resolve(false);
        },
      });
    });
    return promise;
  }

  async SubstituteCoach(substituteCoach: SubstituteCoachInClassRequest) {
    this.classService.SubstituteCoach(this.tenantId, this.classData!.id, substituteCoach)
      .subscribe({
        next: async (data: any) => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.COACH_CHANGE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.classData.coach_id = substituteCoach.coach_id;
          this.eventData!.resource = substituteCoach.coach_id;
          this.selectedTrainerId.next(substituteCoach.coach_id);
          this.emitUpdatedData.emit({
            class: this.classData,
            event: this.eventData,
          });
        },
        error: (error: AppErrors) => {
          this.selectedTrainerId.next(this.classData.coach_id);
          this.ShowToastErrors(error);
        },
      });
  }

  async SubstituteCoachInRecurring(substituteCoach: SubstituteCoachInClassRequest) {
    this.classService.SubstituteCoachInRecurring(this.tenantId,this.classObj!.recurring_id,substituteCoach)
      .subscribe({
        next: (data: any) => {
          this.translate.get('SCHEDULE.VIEWCLASS.MSG.COACH_CHANGE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.reloadData.emit(true);
        },
        error: (error: AppErrors) => {
          this.selectedTrainerId.next(this.classData.coach_id);
          this.ShowToastErrors(error);
        },
      });
  }

  RescheduleClass() {
        let rescheduleClassRequest: RescheduleClassRequest = {} as RescheduleClassRequest;
        var changeDate = this.GetStartDateFormValue;
        rescheduleClassRequest.start_datetime = this.timeConversionService.ConvertLocalDateTimeToUTC(changeDate);
        this.classService.RescheduleClass(this.tenantId,this.classObj!.id,rescheduleClassRequest).subscribe({
        next: (data: any) => {
          this.StartDateFormControl.setValue(changeDate, { emitEvent: false });
          
          this.classData.start_datetime = changeDate;
          this.classData.end_datetime = this.getEndDate();
          this.eventData!.start = this.classData.start_datetime;
          this.eventData!.end = this.classData.end_datetime;
          this.emitUpdatedData.emit({class: this.classData,event: this.eventData});
            this.translate.get('SCHEDULE.VIEWCLASS.MSG.CLASS_RESCHEDULE_CHANGE')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
             
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
          this.StartDateFormControl.setValue(this.classDataObject!.start_datetime, {onlySelf: true, emitEvent: false});
        },
      });
  }

  RescheduleRecurringClass() {
      let rescheduleRecurringClassRequest: RescheduleRecurringClassRequest = {} as RescheduleRecurringClassRequest;
      let service: Observable<any>;
      rescheduleRecurringClassRequest.recurring_rule = this.RRuleObject.RRule;
      rescheduleRecurringClassRequest.start_date = this.timeConversionService.ConvertLocalDateTimeToUTC(this.GetStartDateFormValue);
      rescheduleRecurringClassRequest.start_time = this.timeConversionService.GetUTCTimeFromDate(this.GetStartDateFormValue);
      this.classService.RescheduleRecurringClass(this.tenantId,this.classObj!.recurring_id,rescheduleRecurringClassRequest)
      .subscribe({
        next: (data: any) => {
        this.translate.get('SCHEDULE.VIEWCLASS.MSG.CLASS_RESCHEDULE_CHANGE')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
          this.classData.start_datetime = this.GetStartDateFormValue;
          this.classData.end_datetime = this.getEndDate();
          this.reloadData.emit(true);
      },
      error: (error: AppErrors) => {
        this.ShowToastErrors(error);
        this.StartDateFormControl.setValue(this.classDataObject!.start_datetime, {onlySelf: true,});
      },
    });
  }

  CancelClass(form: any) {
    let cancelRequest: CancelClassRequest = {} as CancelClassRequest;
    cancelRequest.cancellation_reason = form.value.cancellation_reason;
    this.classService.CancelClass(this.tenantId, this.classData.id, cancelRequest)
      .subscribe({
        next: (data: any) => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.CANCEL_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.cancelClassPopup = false;
          this.reloadData.emit(true);
          this.ClosePopup();
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
          this.cancelClassPopup = false;
        },
      });
  }

  DeleteClass() {
    this.classService.DeleteClass(this.tenantId, this.classData.id).subscribe({
      next: async (data: any) => {
        this.translate
          .get('SCHEDULE.VIEWCLASS.MSG.DELETE_MSG')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.reloadData.emit(true);
        await this.timeout(1000);
        this.deleteClassPopup = false;
        this.ClosePopup();
      },
      error: (error: AppErrors) => {
        this.ShowToastErrors(error);
      },
    });
  }

  MarkClassComplete(markCompleted: boolean) {
    if (!markCompleted) {
      this.classService.MarkClassComplete(this.tenantId, this.classObj.id).subscribe({
        next: (data: any) => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.COMPLETE_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.markCompleted = true;
          this.classObj.status = ClassStatus.Completed;
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
          this.deleteClassPopup = false;
        },
      });
    }
  }

  CloseDuplicateClassSidebar(event: any) {
    this.duplicateClass = false;
    if (event.reloadData) this.reloadData.emit(true);
    this.SelectedActionFormControl.setValue(null);
    //this.ClosePopup();
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async UpdateEvent(event: boolean, clickEvent: any = null) {
    switch (this.updateEvent) {
      case 'TrainerChange':
        {
          if (event && clickEvent != null) {
            this.checkStaffAvailability(clickEvent);
          }
          else if(event && clickEvent == null){
            if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
               this.SubstituteCoach(this.currentRequestPayload);
            else this.SubstituteCoachInRecurring(this.currentRequestPayload);

            this.showRecurringEventUpdatePopup = false;
            this.isStaffAvailable=true;
          }
          else {
            this.selectedTrainerId.next(this.classObj!.coach_id);
            this.showRecurringEventUpdatePopup = false;
          }
        }
        break;
      case 'MaxCapacityChange':
      case 'MaxWaitlistChange':
        {
          if (event) {
            this.UpdateMaxCapacityAndWaitlist();
          }
          else {
            this.MaxCapacityFormControl.setValue(this.classData.max_capacity);
            this.MaxWaitListFormControl.setValue(this.classData.max_waitlist);
          }
        }
        break;
      case 'VirtualUrlChange':
        {
          if (event) {
            this.UpdateVirtualUrl();
          }
          else {
            this.VirtualUrlFormControl.setValue(this.classObj!.virtual_url);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break
      case 'DropInChange':
        {
          if (event) {
            this.UpdateDropInStatus();
          }
          else {
            this.selectedDropin = this.dropIns.find((d) => d.value == this.classData!.is_dropin_allowed);
            this.DropInFormControl.setValue(this.selectedDropin);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'RoomChange':
        {
          if (event) {
            this.updateRoom();
          }
          else {
            this.selectedRoomId.next(this.classData!.room_id);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'CommentsChange':
        {
          if (event) {
            this.UpdateCommnets();
          } else {
            this.CommentsFormControl.setValue(this.classObj!.comments);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'OnScheduleDateTimeChange':
      case 'OnScheduleTimeChange':
        {
          if (event && clickEvent != null && this.checkAvailability) {
            this.checkStaffAvailability(clickEvent);
          }
          else if(event && (clickEvent == null || this.checkAvailability == false)){
            if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
              this.RescheduleClass();
           else
             this.RescheduleRecurringClass();

             this.showRecurringEventUpdatePopup = false;
             this.isStaffAvailable=true;
          }
          else {
            this.StartDateFormControl.setValue(this.classData!.start_datetime, { onlySelf: true });
            this.showRecurringEventUpdatePopup = false;
          }
        }
        break;
        case 'AcceptsTrialChange':
          {
            if (event) {
              this.UpdateAcceptsTrial();
            }
            else {
              this.AcceptsTrialFormControl.setValue(this.classData!.accepts_trial);
            }
            this.showRecurringEventUpdatePopup = false;
          }
          break;
    }
  }

  confirm(event: Event) {
    let translation: any;
    this.translate.get(['STAFF_SCHEDULE.MSG.WANT_CHANGES_PROCEES','common.BUTTONS.BUTTON-TEXT-YES','common.BUTTONS.BUTTON-TEXT-NO'])
      .subscribe((translations) => {
        translation = translations;
      });
    this.confirmationService.confirm({
        target: event.target as EventTarget,
        key:'bookconfirm',
        message: translation['STAFF_SCHEDULE.MSG.WANT_CHANGES_PROCEES'],
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          this.UpdateEvent(true);
        },
        reject: () => {
          this.showRecurringEventUpdatePopup = false;
          this.isStaffAvailable=false;
        }
    });
}

  UpdateClassData(event: any) {
    this.classObj = event;
    this.classData.status= this.classObj.status;
    this.classData.max_capacity= this.classObj.max_capacity;
    this.classData.max_waitlist= this.classObj.max_waitlist;
    this.classData.total_booking= this.classObj.total_booking;
    this.classData.total_waitlist_booking= this.classObj.total_waitlist_booking;
    this.emitUpdatedData.emit({class: this.classData,event: this.eventData});
  }

  selectAction(action:any)
  {
    this.selectedClassAction= action.value;
    switch (this.selectedClassAction?.key) {
      case 'DUPLICATE':
         this.duplicateClass = true;
        break;
      case 'CANCEL_CLASS':
        this.cancelClassPopup = true;
        break;
      case 'DELETE':
        this.deleteClassPopup = true;
        break;
      case 'CONVERT_PHYSICAL':
          this.ToggleVirtual(false);
        break;
      case 'CONVERT_VIRTUAL':
        this.ToggleVirtual(true);
      break;
      }
  }

  checkStaffAvailability(event: any= null)
  {
    if(this.selectedClassType && this.StartDateFormControl.value && this.SelectedTrainerFormControl.value.id)
    {
      this.showSkeleton=true;
      this.btnLoading=true;
      const endDateTime: Date = this.getEndDate();
      endDateTime.setMinutes(endDateTime.getMinutes() + this.selectedClassType.duration_in_minutes);
      if (this.SelectedUpdateEventFormControlValue.toLowerCase() !== 'thisevent') {
        let request:CheckRecurringAvailability ={} as CheckRecurringAvailability;
        request.recurring_start_date =  this.timeConversionService.ConvertLocalDateTimeToUTC(this.GetStartDateFormValue);
        request.recurring_end_date = this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime);
        request.start_time =  this.getTimeFromDateString(this.StartDateFormControl.value);
        request.end_time =  this.getTimeFromEndDateString(endDateTime);
        request.recurring_rule = this.RRuleObject.RRule;
        this.staffAvailabilityService.checkStaffAvailabilityForRecurringClass(this.tenantId, this.SelectedTrainerFormControl.value.id, request).subscribe({
          next: async (response: StaffAvailableResponse) => {
            console.log(response);
            this.isStaffAvailable =response.result;
            this.availabilityResponseHandle(event);
          },
          error: (error:any) => {
            this.isStaffAvailable = true;
            this.showSkeleton=false;
            this.availabilityResponseHandle(event);
            this.cd.detectChanges();
          },
        });
      }
      else{
        this.staffAppointmentAvailability.set('start_date', { name: 'start_date', value: this.timeConversionService.ConvertLocalDateTimeToUTC(this.GetStartDateFormValue) });
        this.staffAppointmentAvailability.set('end_date', { name: 'end_date', value: this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime)});
        this.staffAvailabilityService.checkStaffAvailabilityForClass(this.tenantId, this.SelectedTrainerFormControl.value.id, [...this.staffAppointmentAvailability.values()]).subscribe({
          next: async (response: StaffAvailableResponse) => {
            console.log(response);
            this.isStaffAvailable =response.result;
            this.availabilityResponseHandle(event);
            this.cd.detectChanges();
          },
          error: (error:any) => {
            this.isStaffAvailable = true;
            this.showSkeleton=false;
            this.availabilityResponseHandle(event);
            this.cd.detectChanges();
          },
        });
      }
    }
  }

  availabilityResponseHandle(event:any)
  {
    if(this.isStaffAvailable)
    {
      switch (this.updateEvent) {
        case 'TrainerChange':
          {
              if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
                this.SubstituteCoach(this.currentRequestPayload);
              else this.SubstituteCoachInRecurring(this.currentRequestPayload);
          }
          break;
        case 'OnScheduleTimeChange':
        case 'OnScheduleDateTimeChange':
          {
              if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
                this.RescheduleClass();
              else
                this.RescheduleRecurringClass();
          }
          break;
      }
      this.btnLoading=false;
      this.showRecurringEventUpdatePopup = false;
      this.cd.detectChanges();
    }
    else{
      
      this.btnLoading=false;
      const dynamicContent = {
        name: this.SelectedTrainerFormControl.value.name,
        id: this.SelectedTrainerFormControl.value.id
      };
      this.toastMessageService.showCustomWarning("",'main_template',dynamicContent)
      this.confirm(event);
      this.cd.detectChanges();
    }
  }

  getTimeFromDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date = this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getTimeFromEndDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date = this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    date.setSeconds(-1);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getEndDate()
  {
    var newEndDate = new Date(this.GetStartDateFormValue);
    return new Date(newEndDate.setMinutes(this.GetStartDateFormValue.getMinutes() + this.classObj.class_duration));
  }

  get getClassActions()
  {
    return this.classActions.filter(o => o.show == true);
  }

  get StartDateFormControl(): UntypedFormControl {
    return this.classViewForm.controls.startDate as UntypedFormControl;
  }

  get GetStartDateFormValue(): Date {
    return this.classViewForm.controls.startDate.value;
  }

  get MaxCapacityFormControl(): UntypedFormControl {
    return this.classViewForm.controls.maxCapacity as UntypedFormControl;
  }

  get GetMaxCapacityFormValue(): any {
    return this.classViewForm.controls.maxCapacity.value;
  }

  get MaxWaitListFormControl(): UntypedFormControl {
    return this.classViewForm.controls.maxWaitlist as UntypedFormControl;
  }

  get GetMaxWaitListFormValue(): any {
    return this.classViewForm.controls.maxWaitlist.value;
  }

  get SelectedTrainerFormControl(): UntypedFormControl {
    return this.classViewForm.controls.selectedTrainer as UntypedFormControl;
  }

  get GetSelectedTrainerFormValue(): any {
    return this.classViewForm.controls.selectedTrainer.value;
  }

  get SelectedRoomFormControl(): UntypedFormControl {
    return this.classViewForm.controls.selectedRoom as UntypedFormControl;
  }
  get GetSelectedRoomFormValue(): any {
    return this.classViewForm.controls.selectedRoom.value;
  }

  get CommentsFormControl(): UntypedFormControl {
    return this.classViewForm.controls.comments as UntypedFormControl;
  }

  get GetCommentsFormValue(): any {
    return this.classViewForm.controls.comments.value;
  }

  get VirtualUrlFormControl(): UntypedFormControl {
    return this.classViewForm.controls.virtualUrl as UntypedFormControl;
  }

  get GetVirtualUrlFormValue(): any {
    return this.classViewForm.controls.virtualUrl.value;
  }

  get DropInFormControl(): UntypedFormControl {
    return this.classViewForm.controls.isDropInAllowed as UntypedFormControl;
  }

  get GetDropInFormValue(): any {
    return this.classViewForm.controls.isDropInAllowed.value.value;
  }

  get PlaceIdFormControl(): UntypedFormControl {
    return this.classViewForm.controls.placeId as UntypedFormControl;
  }

  get LongitudeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.longitude as UntypedFormControl;
  }

  get LatitudeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.latitude as UntypedFormControl;
  }

  get PlaceNameControl(): UntypedFormControl {
    return this.classViewForm.controls.placeName as UntypedFormControl;
  }

  get clientBookingStatus() {
    return ClientBookingStatus;
  }

  public get ClassStatus(): typeof ClassStatus {
    return ClassStatus;
  }

  get SelectedUpdateEventFormControlValue(): any {
    return this.updateEventForm.controls.updateEvent.value;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus).filter(key => typeof key[1] != 'number').map(([key, value]) => ({ key, value }));
  }

  get AcceptsTrialFormControl(): UntypedFormControl {
    return this.classViewForm.controls.accepts_trial as UntypedFormControl;
  }

  get SelectedBehaviourTypeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.selectedBehaviourType as UntypedFormControl;
  }

  get SelectedClassTypeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.classType as UntypedFormControl;
  }

  get SelectedClassSubTypeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.classSubType as UntypedFormControl;
  }

  get SelectedActionFormControl(): UntypedFormControl {
    return this.classViewForm.controls.selectedAction as UntypedFormControl;
  }
}